import { SettingsAction } from '../../../enums/settingsAction'
import { ReportOptions } from '../../../types/reportOptions'

interface SettingsConfig {
  filterKey: keyof ReportOptions
  tooltipKey: string | null
  translationKey: string
}

export const SETTINGS_CONFIG: Record<SettingsAction, SettingsConfig> = {
  [SettingsAction.HideZeros]: {
    filterKey: 'hideZeroes',
    translationKey: 'reports.filters.hide_zeroes',
    tooltipKey: null,
  },
  [SettingsAction.ShowYTD]: {
    filterKey: 'ytd',
    translationKey: 'reports.filters.show_ytd',
    tooltipKey: null,
  },
  [SettingsAction.ShowChange]: {
    filterKey: 'showChange',
    translationKey: 'reports.filters.show_change',
    tooltipKey: 'reports.filters.show_change_tooltip',
  },
  [SettingsAction.ShowGroupPercentage]: {
    filterKey: 'showGroupPercentage',
    translationKey: 'reports.filters.show_group_percentage',
    tooltipKey: 'reports.filters.show_group_percentage_tooltip',
  },
}
